import React from "react";

const SwitchInside = ({
  leftContent = "ON",
  rightContent = "OFF",
  activeValue = "left",
  onChange,
  className = "",
}) => {
  const handleClick = (value) => {
    if (onChange) {
      onChange(value);
    }
  };

  return (
    <div className={`switch-inside ${(className || "")}`}>
      <button
        type="button"
        className={`switch-inside-btn ${activeValue === "left" ? "switch-inside-btn-active" : ""}`}
        onClick={() => handleClick("left")}
      >
        {(leftContent || "")}
      </button>

      <button
        type="button"
        className={`switch-inside-btn ${activeValue === "right" ? "switch-inside-btn-active" : ""}`}
        onClick={() => handleClick("right")}
      >
        {(rightContent || "")}
      </button>
    </div>
  );
};

export default SwitchInside;
